import React from 'react';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';
import PropTypes from 'prop-types';
import { SvgIcon, Star } from 'fe-comp-svg-icon';

const FULL_STAR_FILL = theme.colorBrandOrange;
const EMPTY_STAR_FILL = theme.colorGrey90;

const PROP_TYPES = {
  rating: PropTypes.number.isRequired,
  numStars: PropTypes.number,
};

const DEFAULT_PROPS = {
  numStars: 5,
};

const StarContainer = styled.div`
  display: inline-block;
  & > svg {
    margin-right: ${theme.spacingXs};

    &:last-child {
      margin-right: ${theme.spacingSm};
    }
  }
`;

const PartialGradientFill = ({ percentFill }) => (
  <svg width="0" height="0">
    <defs>
      <linearGradient id={`partialStarFill${percentFill}`}>
        <stop offset={`${percentFill}%`} stopColor={FULL_STAR_FILL} />
        <stop offset={`${percentFill}%`} stopColor={EMPTY_STAR_FILL} />
      </linearGradient>
    </defs>
  </svg>
);

const getStarFill = (starNumber, rating, percentFill) => {
  let fill = `url(#partialStarFill${percentFill})`;
  if (starNumber <= Math.floor(rating)) {
    fill = FULL_STAR_FILL;
  } else if (starNumber != Math.ceil(rating)) {
    fill = EMPTY_STAR_FILL;
  }
  return fill;
};

const StarRating = ({ rating, numStars }) => {
  const percentFill = Math.round((rating % 1) * 100);
  return (
    <>
      {Boolean(rating % 1) && <PartialGradientFill percentFill={percentFill} />}
      <StarContainer>
        {Array(numStars)
          .fill(0)
          .map((item, i) => (
            <SvgIcon
              key={i}
              glyph={Star}
              size={15}
              fill={getStarFill(i + 1, rating, percentFill)}
            />
          ))}
      </StarContainer>
    </>
  );
};

StarRating.propTypes = PROP_TYPES;
StarRating.defaultProps = DEFAULT_PROPS;
StarRating.displayName = 'StarRating';

export { StarRating };
